<ul class="navbar-nav" [ngSwitch]="usuarioLogado()">
    <li *ngSwitchCase="false" class="nav-item" style="padding-right: 30px;">
        <a class="btn btn-primary" [routerLink]="['/conta/login']">Entrar</a>
    </li>
    <li *ngSwitchCase="true" class="nav-item">
        <a class="nav-link text-light" href="javascript:void(0)" >{{conta.email}}</a>
    </li>
    <li *ngSwitchCase="true" class="nav-item">
        <a class="nav-link text-light" href="javascript:void(0)" (click)="logout()" >Sair</a>
    </li>
</ul>